<div class="toggle--base">
  <input
    class="toggle--input toggle--size-{{ sizeClass }}"
    [checked]="checked"
    [disabled]="disabled"
    type="checkbox"
    name="checkbox"
    (change)="emitCheck()"
  />

  <svg
    *ngIf="checked && color === toggleColor.GREEN"
    class="toggle--svg"
    [attr.width]="svgDimension"
    [attr.height]="svgDimension"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="15" cy="15" r="14.5" [attr.fill]="color" />
    <path
      d="M21.6208 11.3124C21.2043 10.8958 20.5289 10.8958 20.1123 11.3124L13.6666 17.7582L10.1542 14.2457C9.73761 13.8292 9.06223 13.8292 8.64567 14.2457C8.22911 14.6623 8.22911 15.3377 8.64567 15.7542L12.9123 20.0209C13.3289 20.4375 14.0043 20.4375 14.4208 20.0209L21.6208 12.8209C22.0374 12.4043 22.0374 11.729 21.6208 11.3124Z"
      fill="black"
    />
  </svg>

  <svg
    *ngIf="checked && color === toggleColor.BLUE"
    class="toggle--svg"
    [attr.width]="svgDimension"
    [attr.height]="svgDimension"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.6666 15C29.6666 6.91245 23.0868 0.333313 14.9999 0.333313C6.91304 0.333313 0.333252 6.91245 0.333252 15C0.333252 23.0875 6.91304 29.6666 14.9999 29.6666C23.0868 29.6666 29.6666 23.0875 29.6666 15ZM21.6208 11.3124C21.2043 10.8958 20.5289 10.8958 20.1123 11.3124L13.6666 17.7582L10.1542 14.2457C9.73761 13.8292 9.06223 13.8292 8.64567 14.2457C8.22911 14.6623 8.22911 15.3377 8.64567 15.7542L12.9123 20.0209C13.3289 20.4375 14.0043 20.4375 14.4208 20.0209L21.6208 12.8209C22.0374 12.4043 22.0374 11.729 21.6208 11.3124Z"
      [attr.fill]="color"
    />
  </svg>
</div>
